module.exports = "<div class=\"modal-dialog\">\r\n  <div class=\"modal-content\">\r\n     <div class=\"modal-header\">\r\n       <button type=\"button\" class=\"close\" (click)=\"close()\" >&times;</button>\r\n       <h4 class=\"modal-title\">{{title || 'Alert!'}}</h4>\r\n     </div>\r\n     <div class=\"modal-body\">\r\n       <p>{{message || 'TADAA-AM!'}}</p>\r\n     </div>\r\n     <div class=\"modal-footer\">\r\n       <button type=\"button\" class=\"btn btn-primary\" (click)=\"close()\">OK</button>\r\n     </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/alert/alert.component.html
// module id = ./client/app/alert/alert.component.html
// module chunks = main